import { NextPage } from 'next'
import RepaymentChannelScreen from '../screens/RepaymentChannel'
import AppRepaymentChannelScreen from '../screens/App-RepaymentChannel'
import { ScreenWidthPort } from '../ScreenWidthContext'

export const RepaymentChannel: NextPage = () => {
    const { showDesktopUI } = ScreenWidthPort()

    return (
        <>
            {showDesktopUI ? (<RepaymentChannelScreen />) : (<AppRepaymentChannelScreen />)}
        </>
    )
}
